import { useParams } from "react-router-dom";
import { SideTabsPage } from "@/components/shared";
import { accountReports } from "@/components/account/reports";

const AccountReports = () => {
  const { reportId } = useParams<{ reportId?: string }>();

  return (
    <SideTabsPage
      title="Reports"
      description="Your income reports. Filter by date and export to Excel or PDF."
      basePath="/account/reports"
      tabs={accountReports}
      tabId={reportId}
    />
  );
};

export default AccountReports;
